import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import images from '../../data/images.json';
import './Causes.css';

const Causes: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const causes = [
    {
      image: images.causes.childEducation,
      progress: 63,
      donation: '53,458',
      goal: '87,609',
      title: t('home.recentCauses.childEducation.title'),
      description: t('home.recentCauses.childEducation.description'),
    },
    {
      image: images.causes.drinkingWater,
      progress: 42,
      donation: '53,458',
      goal: '87,609',
      title: t('home.recentCauses.drinkingWater.title'),
      description: t('home.recentCauses.drinkingWater.description'),
    },
    {
      image: images.causes.homelessPeople,
      progress: 70,
      donation: '53,458',
      goal: '87,609',
      title: t('home.recentCauses.homelessPeople.title'),
      description: t('home.recentCauses.homelessPeople.description'),
    },
  ];

  return (
    <div className="causes-page">
      <section className="causes-hero">
        <div className="container">
          <h1 className="page-title">{t('causes.title')}</h1>
        </div>
      </section>

      <section className="causes-grid-section">
        <div className="container">
          <h2 className="section-title-large">{t('home.recentCauses.title')}</h2>
          <p className="section-subtitle">{t('home.recentCauses.subtitle')}</p>
          <div className="causes-grid">
            {causes.map((cause, index) => (
              <div key={index} className="cause-card">
                <img 
                  src={cause.image} 
                  alt={cause.title}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = 'https://via.placeholder.com/400x250/f4c430/333333?text=Cause';
                  }}
                />
                <div className="cause-progress">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${cause.progress}%` }}></div>
                    <div className="progress-badge" style={{ left: `${cause.progress}%` }}>
                      {cause.progress}%
                    </div>
                  </div>
                  <p className="donation-info">
                    {t('home.recentCauses.childEducation.donation')} {cause.donation}/${cause.goal}
                  </p>
                </div>
                <div className="cause-details">
                  <h3>{cause.title}</h3>
                  <p>{cause.description}</p>
                  <button 
                    className="donate-button"
                    onClick={() => navigate('/donate-anonymously', { state: { cause: cause.title } })}
                  >
                    {t('home.recentCauses.childEducation.button')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Causes;

